import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { BellIcon, BadgeCheckIcon } from '@heroicons/react/solid';
import { ReactComponent as Logo } from '../../static/logo/logo.svg';
import { ReactComponent as Processing } from '../../static/animations/processing.svg';
import isEmail from 'validator/lib/isEmail';
import { registerUser } from '../../api/users';

export default class BetaInvite extends Component {
  
  state = {
    company: '',
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    confirm_password: '',
    isSubmitting: false,
    waitingList: false,
    errors: {},
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const errors = {};

    if (!this.state.company.length) {
      errors.company = 'Organization name is required!';
    }

    if (!this.state.first_name.length) {
      errors.first_name = 'First name is required!';
    }

    if (!this.state.last_name.length) {
      errors.last_name = 'Last name is required!';
    }

    if (!this.state.email.length) {
      errors.email = 'Email address is required!';
    } else if (!isEmail(this.state.email)) {
      errors.email = 'Please enter a valid email address!';
    }

    if (!this.state.password.length) {
      errors.password = 'Password is required!';
    } else if (this.state.password.length < 8) {
      errors.password = 'Password must be a minimum of 8 characters';
    }

    if (!this.state.confirm_password.length) {
      errors.confirm_password = 'Confirm password is required!';
    } else if (this.state.password !== this.state.confirm_password) {
      errors.confirm_password = `Passwords don't match. Please enter exact same password`;
    }

    this.setState({ errors });

    if (!errors.length) {
      const payload = {
        email: this.state.email,
        password1: this.state.password,
        password2: this.state.confirm_password,
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        company_name: this.state.company,
        subscription_id: 1,
      };

      this.setState({ isSubmitting: true });
      registerUser(payload)
        .then((res) => {
          this.setState({ isSubmitting: false, waitingList: true });
          // console.log('res');
          // console.log(res);
        })
        .catch((err) => {
          this.setState({ isSubmitting: false });

          if ('company_name' in err) {
            errors.company = err.company_name.join(', ');
          }
          if ('first_name' in err) {
            errors.first_name = err.first_name.join(', ');
          }
          if ('last_name' in err) {
            errors.last_name = err.last_name.join(', ');
          }
          if ('email' in err) {
            errors.email = err.email.join(', ');
          }
          if ('password1' in err) {
            errors.password = err.password1.join(', ');
          }
          if ('password2' in err) {
            errors.confirm_password = err.password2.join(', ');
          }

          // console.log('errors', errors);
          this.setState({ errors });
        });
    }
  };

  render() {
    let processing;
    if (this.state.isSubmitting) {
      processing = <Processing className='mr-3 h-5 w-5 animate-spin text-white' />;
    }

    if (this.state.waitingList) {
      return (
        <div className='bg-white min-h-screen flex flex-col'>
          <div className='container mx-auto'>
            <div className='w-1/2 mx-auto'>
              <div className='mt-8'>
                <Logo className='mx-auto' />
              </div>
              <div className='p-6 my-5'>
                <div className='w-full p-5 rounded-lg border border-green-200 bg-green-50 text-green-700'>
                  <div className='flex'>
                    <BadgeCheckIcon className='w-8 h-8 text-green-700' />
                    <h3 className='ml-1 font-bold text-2xl'>Awesome!</h3>
                  </div>
                  <h5 className='mt-3'>
                    We've received your information. You'll be notified via email once your account has been reviewed and accepted.
                  </h5>
                  <h5 className='mt-3'>
                    If you have any questions, please use the contact form on our website:{' '}
                    <a className='text-blue-600' href='https://chipbrain.com/#contact' target='_blank' rel='noopener noreferrer'>
                      https://chipbrain.com/#contact
                    </a>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className='bg-white min-h-screen flex flex-col'>
        <div className='container mx-auto'>
          <div className='w-1/2 mx-auto'>
            <div className='mt-8'>
              <Logo className='mx-auto' />
            </div>

            <form className='p-6 my-5' onSubmit={this.handleSubmit}>
              <h1 className='text-black font-semibold text-2xl mb-5'>Create your account</h1>

              <div className='flex items-center bg-yellow-50 border border-yellow-100 rounded p-3 mb-4 text-base text-yellow-700' role='alert'>
                <BellIcon className='h-5 w-5' />
                <div className='ml-2'>Chipbrain is currently invite only.</div>
              </div>

              <div className=' mb-4'>
                <label className='block mb-1' htmlFor='organization'>
                  Organization
                </label>
                <input
                  type='text'
                  className={`block border w-full p-3 rounded ${this.state.errors.company ? 'border-red-500' : 'border-gray-300'}`}
                  value={this.state.company}
                  name='company'
                  onChange={this.handleChange}
                  id='organization'
                />
                <p className='text-red-500 text-sm py-1'>{this.state.errors.company}</p>
              </div>

              <div className='flex flex-wrap -mx-2 mb-4 space-y-4 md:space-y-0'>
                <div className='w-full px-2 md:w-1/2'>
                  <label className='block mb-1' htmlFor='first_name'>
                    First name
                  </label>
                  <input
                    className={`block border w-full p-3 rounded ${this.state.errors.first_name ? 'border-red-500' : 'border-gray-300'}`}
                    type='text'
                    id='first_name'
                    value={this.state.first_name}
                    name='first_name'
                    onChange={this.handleChange}
                  />
                  <p className='text-red-500 text-sm py-1'>{this.state.errors.first_name}</p>
                </div>
                <div className='w-full px-2 md:w-1/2'>
                  <label className='block mb-1' htmlFor='last_name'>
                    Last name
                  </label>
                  <input
                    className={`block border w-full p-3 rounded ${this.state.errors.last_name ? 'border-red-500' : 'border-gray-300'}`}
                    type='text'
                    id='last_name'
                    value={this.state.last_name}
                    name='last_name'
                    onChange={this.handleChange}
                  />
                  <p className='text-red-500 text-sm py-1'>{this.state.errors.last_name}</p>
                </div>
              </div>

              <div className='mb-4'>
                <label className='block mb-1' htmlFor='email'>
                  Email
                </label>
                <input
                  type='text'
                  className={`block border w-full p-3 rounded ${this.state.errors.email ? 'border-red-500' : 'border-gray-300'}`}
                  id='email'
                  value={this.state.email}
                  name='email'
                  onChange={this.handleChange}
                />
                <p className='text-red-500 text-sm py-1'>{this.state.errors.email}</p>
              </div>

              <div className='mb-4'>
                <label className='block mb-1' htmlFor='password'>
                  Password
                </label>
                <input
                  type='password'
                  className={`block border w-full p-3 rounded ${this.state.errors.password ? 'border-red-500' : 'border-gray-300'}`}
                  id='password'
                  value={this.state.password}
                  name='password'
                  onChange={this.handleChange}
                />
                <p className='text-red-500 text-sm py-1'>{this.state.errors.password}</p>
              </div>

              <div className='mb-4'>
                <label className='block mb-1' htmlFor='confirm_password'>
                  Confirm Password
                </label>
                <input
                  type='password'
                  className={`block border w-full p-3 rounded ${this.state.errors.confirm_password ? 'border-red-500' : 'border-gray-300'}`}
                  id='confirm_password'
                  value={this.state.confirm_password}
                  name='confirm_password'
                  onChange={this.handleChange}
                />
                <p className='text-red-500 text-sm py-1'>{this.state.errors.confirm_password}</p>
              </div>

              <div className='mb-4'>
                By submitting you agree to our{' '}
                <Link target='_blank' to='/company/terms-of-service' className='text-indigo-500 hover:text-indigo-700 visited:text-indigo-500'>
                  terms of service
                </Link>
              </div>

              <button
                type='submit'
                className='rounded bg-indigo-700 w-full px-6 py-3 text-white flex items-center place-content-center'
                disabled={this.state.isSubmitting}
              >
                <span className='font-medium mr-2'> Create Account </span>
                {processing}
              </button>
            </form>

            <div className='mt-2 mb-20 block text-center px-6'>
              Already have an account?
              <Link className='text-indigo-500 hover:text-indigo-700 visited:text-indigo-500 ml-2 font-medium' to='/'>
                Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
